import { render, staticRenderFns } from "./UpdateGoPricing.vue?vue&type=template&id=21aeefcc&scoped=true"
import script from "./UpdateGoPricing.vue?vue&type=script&lang=js"
export * from "./UpdateGoPricing.vue?vue&type=script&lang=js"
import style0 from "./UpdateGoPricing.vue?vue&type=style&index=0&id=21aeefcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aeefcc",
  null
  
)

export default component.exports